import axios from "axios"

export interface InfrastructureStatus {
  isMaintenance: boolean
  requiredVersion: string
}

// Same source of truth as the mobile app (EXPO_PUBLIC_STATUS_API_URL): the
// standalone status service, toggled from the telegram bot. Deliberately not
// the API's /infrastructure proxy - during maintenance the API container is
// the thing that is down.
const STATUS_API_URL = import.meta.env.VITE_STATUS_API_URL as string | undefined
const STATUS_TIMEOUT_MS = 4000

/**
 * null = unknown (status service unreachable, bad payload, or the URL is not
 * configured). Callers fail open: an outage of the status service must never
 * lock users out of the web app.
 */
export const getInfrastructureStatus =
  async (): Promise<InfrastructureStatus | null> => {
    if (!STATUS_API_URL) return null
    try {
      const { data } = await axios.get<InfrastructureStatus>(STATUS_API_URL, {
        timeout: STATUS_TIMEOUT_MS,
      })
      return typeof data?.isMaintenance === "boolean" ? data : null
    } catch {
      return null
    }
  }
